import axios from "axios";

import { resolvePickupArrivalTime, locationDisplayLabel, parseRouteStopSchedule } from "../utils/routeStopSchedule";
import { fetchRouteStopsSchedule } from "./busServices";

// Function to log in to the SMS service
const loginToSMSService = async () => {
  try {
    const response = await axios.post("https://e-sms.dialog.lk/api/v1/login", {
      username: "vishexuser",
      mask: "VishmithaEx",
      password: "VishEx@123",
    });

    const token = response.data.token; // Assuming the token is returned in the response
    return token;
  } catch (error) {
    console.error("Error logging in to SMS service:", error);
    return null;
  }
};

// Function to send SMS
const sendSMS = async (token, mobileNumber, messageContent) => {
  try {
    const response = await axios.post(
      "https://e-sms.dialog.lk/api/v2/sms",
      {
        msisdn: [{ mobile: mobileNumber }],
        sourceAddress: "VishmithaEx",
        message: messageContent,
        transaction_id: String(Date.now()), // Unique transaction ID
        payment_method: "0",
        push_notification_url: "https://vishmithahighway.lk/",
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, // Assuming Bearer token is needed
        },
      }
    );

    // console.log("SMS sent successfully:", response.data);
  } catch (error) {
    console.error("Error sending SMS:", error);
  }
};

const extractEnglishWord = locationDisplayLabel;

const formatSeatGender = (seatGender) => {
  let formattedString = "";
  for (const seat in seatGender) {
    formattedString += `\n\t\t${seat}(${seatGender[seat]})\n`;
  }
  return formattedString;
};

export const sendSMSNow = async (
  bookingDetails,
  total,
  seatGender,
  BusStartTime,
  BusStartFrom,
  routeStops = null,
  routeContext = {},
) => {
  const token = await loginToSMSService();

  let stopsRaw = routeStops;
  const routeId = routeContext.routeId ?? null;
  const hasTimedStops =
    stopsRaw != null && parseRouteStopSchedule(stopsRaw).some((s) => s.time);
  if (routeId && !hasTimedStops) {
    try {
      const fresh = await fetchRouteStopsSchedule(routeId);
      if (fresh && parseRouteStopSchedule(fresh).some((s) => s.time)) {
        stopsRaw = fresh;
      }
    } catch (error) {
      console.error("fetchRouteStopsSchedule for SMS:", error.message);
    }
  }

  const boardingTime = resolvePickupArrivalTime(
    stopsRaw,
    bookingDetails?.from,
    BusStartTime,
    {
      ...routeContext,
      originLocation: routeContext.originLocation ?? BusStartFrom,
      originTime: routeContext.originTime ?? BusStartTime,
    },
  );

  if (token) {
    let msg_old =
      "NF5272\n\nDate: " +
      bookingDetails.date +
      "\nBus start from: " +
      BusStartFrom +
      "\nStart time : " +
      BusStartTime +
      "\nNIC: " +
      (bookingDetails.nic == undefined ? "N/A" : bookingDetails.nic) +
      "\nSEATS :" +
      formatSeatGender(seatGender) +
      "\nONE SEAT: " + (total / Math.max(Object.keys(seatGender).length, 1)) + "/= \nFROM :" +
      extractEnglishWord(bookingDetails.from) +
      "\nTo :" +
      extractEnglishWord(bookingDetails.to) +
      "\nTotal Amount: " +
      total +
      "/=\n\n+94 766333030 | +94 775333030\nTHANK YOU...\nVisit us for online bookings!\nhttps://vishmithahighway.lk/";

    // VISHMITHA HIGHWAY EXPRESS
    // 246/6B, Kumarasinghe Road, Badulla
    // NF5272

    // Date: 2025-08-13
    // Bus start from: Makumbura
    // Start time : 06.30 PM
    // NIC: N/A
    // SEATS :
    // 		6(male)

    // ONE SEAT: 2440/=
    // FROM :Makumbura
    // To :Badulla
    // Total Amount: 2440/=

    // +94 766333030 | +94 775333030
    // THANK YOU...
    // Visit us for online bookings!
    // https://vishmithahighway.lk/

    const msg = `Date: ${bookingDetails.date}\nFrom: ${extractEnglishWord(
      bookingDetails.from
    )}\nTo: ${extractEnglishWord(
      bookingDetails.to
    )}\nReach by: ${boardingTime}\nSeats: ${Object.entries(seatGender)
      .map(([seat, gender]) => `${seat}(${gender})`)
      .join(
        ","
      )}\nTotal: ${total}/=\nCall: +94766333030\nBook: https://vishmithahighway.lk/`;

    // Date: 2025-08-15
    // From: Colombo
    // To: Kandy
    // Time: 08:30 AM
    // Seats: 1(M),2(F),1(M),2(F)
    // Total: 4380/=
    // Call: +94766333030
    // Book: https://vishmithahighway.lk/

    await sendSMS(token, bookingDetails.mobile_no, msg);
  }
};
